/* eslint-disable max-len, no-irregular-whitespace */
export const TERMS_TITLE = 'ペストビジョン利用規約';

export const TERMS_TEXT = `
環境機器株式会社（以下「当社」という）は、人工知能・機械学習、独自のアルゴリズムを活用した害虫・害獣モニタリングのための各種サービスである「ペストビジョン」（以下「本サービス」という）の利用に関し、以下のとおり利用規約を定めます。本サービスの契約者及び利用者は、あらかじめこの利用規約に同意の上、本サービスを利用するものとします。

第１章 総則

（本サービスの提供と利用規約）
第１条 当社は、この利用規約（以下「利用規約」という）に基づき、本サービスを提供します。
２．本サービスの内容は、各専用ハードウェア及びコンピュータプログラムの提供であり、本サービスを利用することで得られる画像、動画、解析結果などのデータ管理については契約者及び利用者が責任を負うものとします。
３．利用規約と個別の当事者間の合意内容が異なるときは、個別の合意内容が利用規約に優先して適用されるものとします。

（定義）
第２条 利用規約においては、次の用語はそれぞれ次の意味で使用します。
  （１）本サービス　利用規約に基づき当社が、「アプリケーション・サービス・プロバイダ」として契約者に提供する「ペストビジョンＲ型、ペストビジョンＳ型、ペストビジョンＦ型、ペストビジョンＦＣ型」等のシステムを活用したサービス一式
  （２）契約者　利用規約に同意し利用契約申込書を提出することで利用契約を当社と締結し、本サービスの提供を受ける者
  （３）利用者　契約者の顧客、委託業者等の第三者で、利用規約に同意し利用規約同意書を提出することで、契約者の責任下で本サービスを利用する者
  （４）利用契約　利用規約に基づき当社と契約者との間に締結される本サービスの提供に関する契約
  （５）契約者設備　本サービスの提供を受けるため契約者等が設置するコンピュータ、電気通信設備その他の機器及びソフトウェア
  （６）本サービス用設備　本サービスを提供するにあたり、当社が設置するサーバー、コンピュータ、電気通信設備その他の機器及びソフトウェア、電気通信事業者より借り受ける電気通信回線等。また契約者設備に格納する本サービスを提供するために必要なソフトウェア一式を含みます。
  （７）ユーザＩＤ　契約者又は利用者とその他の者を識別するために用いられる符号
  （８）パスワード　ユーザＩＤと組み合わせて、契約者又は利用者とその他の者を識別するために用いられる符号
  （９）消費税等　消費税法及び同法に関連する法令の規定に基づき課税される消費税の額並びに地方税法及び同法に関連する法令の規定に基づき課税される地方消費税の額その他契約者が支払に際して負担すべき公租公課

（通知）
第３条 当社から契約者への通知は、当事者間で別段の方法を定めない限り、通知内容を電子メール、書面又は当社のホームページに掲載するなど、当社が適当と判断する方法により行います。
２．前項の規定に基づき、当社から契約者への通知を電子メールの送信又は当社のホームページへの掲載の方法により行う場合には、契約者に対する当該通知は、それぞれ電子メールの送信又はホームページへの掲載がなされた時点から効力を生じるものとします。

（利用規約の変更）
第４条 当社は、利用規約を随時変更することがあります。なお、この場合には、契約者及び利用者の利用条件その他利用契約の内容は、変更後の新利用規約を適用するものとします。
２．当社は、前項の変更を行う場合は、６０日間の予告期間をおいて、変更後の新利用規約の内容を契約者に通知するものとします。契約者において規約変更につき異議がある場合は、この予告期間内に書面により申し出るものとします。
３．契約者は、当社から利用規約の変更の通知を受けた場合、５営業日以内に契約者が本サービスを利用させた利用者に対し、その内容を通知するものとします。利用者において規約変更につき異議がある場合、契約者から通知を受けた日から３０日以内に書面により申し出るものとします。契約者は利用者から異議の申し出を受けた場合、前項の予告期間内に書面により当社に申し出るものとします。
４．契約者が前項の通知を怠ったことにより、利用者が利用規約の変更を知らなかった場合でも、当社と利用者との関係において新利用規約が適用されます。これにより利用者との間でトラブルが生じた場合、契約者が自己の責任と費用負担により解決するものとします。

（権利義務譲渡の禁止）
第５条 契約者及び利用者は、あらかじめ当社の書面による承諾がない限り、利用契約上の地位、利用契約に基づく権利又は義務の全部又は一部を他に譲渡してはならないものとします。

（合意管轄）
第６条 契約者又は利用者と当社の間で訴訟の必要が生じた場合には、大阪地方裁判所をもって合意による専属管轄裁判所とします。

（準拠法）
第７条 利用契約の成立、効力、履行及び解釈に関する準拠法は、日本法とします。

（協議等）
第８条 当社と契約者との間で、利用規約に規定のない事項及び規定された項目について疑義が生じた場合は両者誠意を持って協議の上解決することとします。なお、利用規約の何れかの部分が無効である場合でも、利用規約全体の有効性には影響がないものとし、かかる無効の部分については、当該部分の趣旨に最も近い有効な規定を無効な部分と置き換えるものとします。

第２章 契約の締結等

（利用契約の締結等）
第９条 利用契約は、本サービスの利用申込者が、当社所定の利用契約申込書又は利用規約同意書を当社に提出し、当社がこれに対し当社所定の方法により承諾の通知を発信したときに成立するものとします。なお、本サービスの利用申込者は利用規約の内容を承諾の上、かかる申込を行うものとし、本サービスの利用申込者が申込を行った時点で、当社は、本サービスの利用申込者が利用規約の内容を承諾しているものとみなします。
２．利用契約の変更は、契約者が当社所定の利用変更申込書を当社に提出し、当社がこれに対し当社所定の方法により承諾の通知を発信したときに成立するものとします。
３．当社は、前項の規定にかかわらず、本サービスの契約者が次の各号のいずれかに該当する場合には、利用契約を締結しないことができます。
  （１）過去に金銭債務の不履行、その他利用契約等に違反したことを理由として利用契約を解除されたことがあるとき
  （２）利用申込書又は利用変更申込書に虚偽の記載、誤記があったとき又は記入もれがあったとき
  （３）金銭債務その他利用契約に基づく債務の履行を怠るおそれがあるとき
  （４）その他当社が不適当と判断したとき

（変更通知）
第１０条 契約者は、その商号若しくは名称、本店所在地若しくは住所、連絡先その他利用申込書の契約者にかかわる事項に変更があるときは、当社の定める方法により変更予定の３０日前までに当社に通知するものとします。
２．当社は、契約者が前項に従った通知を怠ったため通知の不到達その他の事由により契約者及び利用者に損害が生じた場合であっても、一切責任を負わないものとします。

（一時的な中断及び提供停止）
第１１条 当社は、次の各号のいずれかに該当する場合には、契約者及び利用者への事前の通知又は承諾を要することなく、本サービスの提供を中断することができるものとします。
  （１）本サービス用設備等の故障により保守を行う場合
  （２）運用上又は技術上の理由でやむを得ない場合
  （３）その他天災地変等不可抗力により本サービスを提供できない場合
２．当社は、本サービス用設備等の定期点検を行うため、契約者に事前に通知の上、本サービスの提供を一時的に中断できるものとします。
３．当社は、契約者が第１５条（当社からの利用契約の解約）のいずれかに該当する場合又は利用契約に違反した場合には、契約者及び利用者への事前の通知若しくは催告の上、本サービスの全部又は一部の提供を停止することができるものとします。
４．当社は、前各項に定める事由のいずれかにより本サービスを提供できなかったことに関して契約者及び利用者又はその他の第三者が損害を被った場合であっても、一切責任を負わないものとします。

（利用期間）
第１２条 本サービスの利用期間は、契約日より１年とします。ただし、当社が定める方法により期間満了３０日前までに契約者又は当社から別段の意思表示がないときは、利用契約は期間満了日の翌日からさらに１年間自動的に更新されるものとし、以後もまた同様とします。
２．当社は、本サービスの利用期間満了の３０日前までに、契約者に利用契約の変更内容を通知することにより、更新後における本サービスの種類、内容及び利用契約内容を変更することができるものとします。

（最短利用期間）
第１３条 本サービスの最短利用期間は、原則として、契約者に本サービスの提供を開始した日から起算して６ヶ月とします。
２．契約者は、前項の最短利用期間内に利用契約の解約を行う場合は、第１４条（契約者からの利用契約の解約）に従うことに加え、当社が定める期限までに、解約日以降最短利用期間満了日までの残余の期間に対応する利用料金に相当する額及びその消費税相当額を一括して当社に支払うものとします。

（契約者からの利用契約の解約）
第１４条 契約者は、解約希望日の３０日前までに当社が定める方法により当社に通知することにより、解約希望日をもって利用契約を解約することができるものとします。
２．契約者は、前項に定める通知が当社に到達した時点において未払いの利用料金等又は支払遅延損害金がある場合には、直ちにこれを支払うものとします。

（当社からの利用契約の解約及び利用者の本サービスの利用停止）
第１５条 当社は、契約者が次の各号のいずれかに該当すると判断した場合、契約者への事前の通知若しくは催告の上、利用契約の全部若しくは一部を解約できるものとします。
  （１）利用契約申込書、その他通知内容等に虚偽記入又は記入もれがあった場合
  （２）支払停止又は支払不能となった場合
  （３）手形又は小切手が不渡りとなった場合
  （４）差押え、仮差押え若しくは競売の申立があったとき又は公租公課の滞納処分を受けた場合
  （５）破産、会社整理開始、会社更生手続開始若しくは民事再生手続開始の申立があったとき又は信用状態に重大な不安が生じた場合
  （６）監督官庁から営業許可の取消、停止等の処分を受けた場合
  （７）利用契約又は利用規約に違反し、当社がかかる違反の是正を催告した後合理的な期間内に是正されない場合
  （８）解散、減資、営業の全部又は重要な一部の譲渡等の決議をした場合
  （９）その他利用契約の継続が困難となる事由が生じた場合
２．契約者は、前項による利用契約の解約があった時点において未払いの利用料金等又は支払遅延損害金がある場合には、当社が定める日までにこれを支払うものとします。
３．当社は、利用者が第３１条の禁止事項に違反すると判断した場合、当該利用者による本サービスの利用を停止することができるものとします。

（本サービスの廃止）
第１６条 当社は、次の各号のいずれかに該当する場合、本サービスの全部又は一部を廃止するものとし、廃止日をもって利用契約の全部又は一部を解約することができるものとします。
  （１）廃止日の１８０日前までに契約者に通知した場合
  （２）天災地変等不可抗力により本サービスを提供できない場合
２．前項に基づき本サービスの全部又は一部を廃止する場合、当社は、既に支払われている利用料金等のうち、廃止する本サービスについて提供しない日数に対応する額を日割計算にて契約者に返還するものとします。

（データ管理・閲覧）
第１７条 契約者及び利用者は、自らの責任で契約期間中データ管理を行うものとします。契約終了後は、当社は契約者及び利用者が本サービスを利用したデータを破棄しますので、契約者の責任で必要に応じて別途管理するものとします。
２．契約者及び利用者は、当社が契約者のために第２１条のサポートサービスを行う場合、ユーザＩＤ又はパスワードを発行する場合、当社が契約者の求めに応じデータの復旧作業を行う場合、その他本サービスの管理保守上必要な場合、当社が管理プログラムによって本サービス上に登録されたデータを閲覧することを認めるものとします。

（契約終了後の処理）
第１８条 契約者は、利用契約が終了した場合、当社から貸し出しを受けた本サービス用設備、及びそれに関わる全ての資料等（当該ソフトウェア及び資料等の全部又は一部の複製物を含みます。以下同じとします。）を利用契約終了後直ちに当社に返還し、契約者設備などに格納されたソフトウェア及び資料等については、契約者の責任で消去又は廃棄するものとします。
２．当社は、利用契約が終了した場合、本サービスの利用にあたって契約者から提供を受けた資料等（資料等の全部又は一部の複製物を含みます。以下同じとします。）を利用契約終了後直ちに契約者に返還し、本サービス用設備などに記録された資料等については、当社の責任で廃棄するものとします。

第３章 サービス

（本サービス利用における留意点）
第１９条 契約者及び利用者は以下の事項を了承の上、本サービスを利用するものとします。
  （１）第３９条（免責）第１項各号に掲げる場合を含め、本サービスに当社に起因しない不具合が生じる場合があること
  （２）当社に起因しない本サービスの不具合については、当社は一切の責を免れること
２．契約者及び利用者は、利用規約に基づいて、本サービスを利用することができるものであり、本サービスに関する知的財産権その他の権利を取得するものでないことを承諾します。

（本サービスの提供区域）
第２０条 本サービスの提供区域は、当事者間で特段の合意を行わない限り、日本国内に限定されるものとします。

（サポート）
第２１条 当社は、下記のサポートサービスを契約者に対して提供するものとします。
  （１）内容と種類
    ①本サービスの利用方法に関する質問への回答及び助言
    ②契約者設備の利用方法に関する質問への助言
    ③契約者設備の障害部位の切り分け、障害復旧に関する質問への助言
    ④提供可能になった場合の、本サービス用設備におけるソフトウェアの更新版の提供
  （２）サービス窓口（連絡先）
    利用契約において、電話、ＦＡＸ、電子メールアドレス等の連絡先を定めるものとします。
  （３）サービス時間
    当社の営業日、９時から１７時まで

（当社による委託）
第２２条 当社は、契約者及び利用者に対する本サービスの提供に関して必要となる業務の全部又は一部を当社の判断にて第三者に委託することができます。この場合、当社は、当該委託先に対し、第３４条（秘密情報の取り扱い）及び第３５条（個人情報の取り扱い）のほか当該委託業務遂行について利用規約所定の当社の義務と同等の義務を負わせるものとします。

第４章 利用料金

（本サービスの利用料金、算定方法等）
第２３条 本サービスの利用料金、算定方法等は、利用契約申込書の利用サービス及び料金に定めるとおりとします。

（利用料金の支払義務）
第２４条 契約者は、サービス利用開始日から利用契約の終了日までの期間（以下「利用期間」という。）について、利用申込書の料金表に定める利用料金及びこれにかかる消費税等を利用契約等に基づき支払うものとします。なお、契約者が本条に定める支払を完了しない場合、当社は、第１１条（一時的な中断及び提供停止）第３項の定めに従い、本サービスの提供を停止することができるものとします。
２．利用期間において、第１１条（一時的な中断及び提供停止）に定める本サービスの提供の中断、停止その他の事由により本サービスを利用することができない状態が生じたときであっても、契約者は、利用期間中の利用料金及びこれにかかる消費税等の支払を要します。ただし、月額制による本サービス（ペストビジョンＦ型、ＦＣ型、Ｒ型）の利用について当社の責に帰すべき事由により本サービスを全く利用できない状態（以下「利用不能」といいます。）が２４時間以上となる場合、利用不能の日数（１日未満は切り捨て）に対応する当該料金制の利用料金及びこれにかかる消費税相当額については、この限りではありません。

（利用料金の支払方法）
第２５条 契約者は、本サービスの利用料金及びこれにかかる消費税等を、次の各号のいずれかの方法で支払うものとします。なお、次の各号の支払に必要な振込手数料その他の費用は、契約者の負担とします。
  （１）請求書により決済する場合、当社からの請求書に従い当社が指定する期日までに当社の指定する方法により、当社あるいは当社指定の金融機関に支払うか、当社が別途指定する集金代行業者を通じて当社が指定する期日までに、契約者が指定する預金口座から自動引き落としにより支払うものとします。
  （２）その他当社が定める支払方法により支払うものとします。
２．契約者と前項の金融機関との間で利用料金の決済をめぐって紛争が発生した場合、契約者が自らの責任と負担で解決するものとし、当社は一切の責任を負わないものとします。

（遅延利息）
第２６条 契約者が、本サービスの利用料金その他の利用契約等に基づく債務を所定の支払期日を過ぎてもなお履行しない場合、契約者は、所定の支払期日の翌日から支払日の前日までの日数に、年１４．５％の利率で計算した金額を延滞利息として、本サービスの料金その他の債務と一括して、当社が指定する期日までに当社の指定する方法により支払うものとします。
２．前項の支払に必要な振込手数料その他の費用は、契約者の負担とします。

第５章 契約者の義務等

（契約者による利用者等に対する責任）
第２７条 契約者は、自己の責任において、利用者などの第三者に本サービスを含むサービスを提供することができます。その際契約者は、本サービスの利用に伴い、自己の責に帰すべき事由で利用者に対して損害を与えた場合、又は利用者からクレーム等の請求がなされた場合、自己の責任と費用をもって処理、解決するものとします。契約者が本サービスの利用に伴い、利用者から損害を被った場合、又は利用者に対してクレーム等の請求を行う場合においても同様とします。また、契約者は自己の責任において、利用者についても、第３１条（禁止事項）、第３４条（秘密情報の取り扱い）、第３５条（個人情報の取り扱い）を遵守させる義務を負います。
２．本サービスを利用して契約者が利用者に提供又は伝送する情報（コンテンツ）については、契約者の責任で提供されるものであり、当社はその内容等についていかなる保証も行わず、また、それに起因する損害についてもいかなる責任も負わないものとします。

（本サービス利用のための設備設定・維持）
第２８条 契約者は、自己の費用と責任において、当社が定める条件にて契約者設備を設定し、契約者設備及び本サービス利用のための環境を維持するものとします。
２．契約者は、本サービスを利用するにあたり自己の責任と費用をもって、電気通信事業者等の電気通信サービスを利用して契約者設備をインターネットに接続するものとします。
３．契約者設備、前項に定めるインターネット接続並びに本サービス利用のための環境に不具合がある場合、当社は契約者に対して本サービスの提供の義務を負わないものとします。
４．当社は、当社が本サービスに関して保守、運用上又は技術上必要であると判断した場合、契約者等が本サービスにおいて提供、伝送するデータ等について、監視、分析、調査等必要な行為を行うことができます。

（ユーザＩＤ及びパスワード）
第２９条 契約者及び利用者は、ユーザＩＤ及びパスワードを第三者に開示、貸与、共有しないとともに、第三者に漏洩することのないよう厳重に管理（パスワードの適宜変更を含みます。）するものとします。ユーザＩＤ及びパスワードの管理不備、使用上の過誤、第三者の使用等により契約者自身及びその他の者が損害を被った場合、当社は一切の責任を負わないものとします。契約者のユーザＩＤ及びパスワードによる利用その他の行為は、全て契約者による利用とみなすものとします。
２．第三者が契約者のユーザＩＤ及びパスワードを用いて、本サービスを利用した場合、当該行為は契約者の行為とみなされるものとします。また、当該行為により当社が損害を被ったとき、契約者は当該損害を補填するものとします。

（バックアップ）
第３０条 契約者及び利用者が本サービスにおいて提供、伝送するデータ等については、契約者及び利用者は自らの責任で同一のデータ等をバックアップとして保存しておくものとし、当社はかかるデータ等の保管、保存、バックアップ等に関して、一切責任を負わないものとします。

（禁止事項）
第３１条 契約者及び利用者は本サービスの利用に関して、以下の行為を行わないものとします。
  （１）当社若しくは第三者の著作権、商標権などの知的財産権その他の権利を侵害する行為、又は侵害するおそれのある行為
  （２）利用契約が存続する間および利用契約の終了後１年間において、当社の事前の書面による承諾を得ることなく、自ら又は第三者を通して、本サービスと類似または競合するサービスの開発、提供を行うことを目的として本サービスを利用する行為
  （３）本サービスの内容や本サービスにより利用しうる情報を改ざん又は消去する行為
  （４）当社との合意なく当社が指定した専用捕虫紙を使用せずに本サービスを利用する行為（ペストビジョンＳ型、Ｆ型、ＦＣ型）
  （５）解析ソフト（ペストビジョンＲ型）、Windowsアプリケーション（ペストビジョンＳ型）のリバースエンジニアリング、逆コンパイル、逆アセンブル、修正、改変、又は派生ソフトウェアの作成を行う行為
  （６）法令若しくは公序良俗に違反し、又は当社若しくは第三者に不利益を与える行為
２．当社は、本サービスの利用に関して、契約者の行為が第１項各号のいずれかに該当するものであることを知った場合、事前に契約者に通知することなく、本サービスの全部又は一部の提供を一時停止し、又は第１項各号に該当する行為に関連する情報を削除することができるものとします。ただし、当社は、契約者の行為又は契約者が提供又は伝送する情報（データ、コンテンツを含みます。）を監視する義務を負うのではありません。

第６章 当社の義務等

（善管注意義務）
第３２条 当社は、本サービスの利用期間中、善良なる管理者の注意をもって本サービスを提供するものとします。

（本サービス用設備等の障害等）
第３３条 当社は、本サービス用設備等について障害があることを知ったときは、遅滞なく契約者にその旨を通知するものとします。
２．当社は、当社の設置した本サービス用設備に障害があることを知ったときは、遅滞なく本サービス用設備を修理又は復旧します。
３．当社は、本サービス用設備等のうち、本サービス用設備に接続する当社が借り受けた電気通信回線について障害があることを知ったときは、当該電気通信回線を提供する電気通信事業者に修理又は復旧を指示するものとします。
４．上記のほか、本サービスに不具合が発生したときは、契約者及び当社はそれぞれ遅滞なく相手方に通知し、両者協議のうえ各自の行うべき対応措置を決定したうえでそれを実施するものとします。

第７章 秘密情報等の取り扱い

（秘密情報の取り扱い）
第３４条 契約者及び当社は、本サービス遂行のため相手方より提供を受けた技術上又は営業上その他業務上の情報のうち、相手方が特に秘密である旨あらかじめ書面で指定し提供の際に秘密情報の範囲を特定し、秘密情報である旨の表示を明記した情報（以下「秘密情報」といいます。）を第三者に開示又は漏洩しないものとします。ただし、相手方からあらかじめ書面による承諾を受けた場合及び次の各号のいずれかに該当する情報についてはこの限りではありません。
  （１）秘密保持義務を負うことなく既に保有している情報
  （２）秘密保持義務を負うことなく第三者から正当に入手した情報
  （３）相手方から提供を受けた情報によらず、独自に開発した情報
  （４）利用契約等に違反することなく、かつ、受領の前後を問わず公知となった情報
  （５）本条に従った指定、範囲の特定や秘密情報である旨の表示がなされず提供された情報
２．前項の定めにかかわらず、契約者及び当社は、秘密情報のうち法令の定めに基づき又は権限ある官公署からの要求により開示すべき情報を、当該法令の定めに基づく開示先又は当該官公署に対し開示することができるものとします。この場合、契約者及び当社は、関連法令に反しない限り、当該開示前に開示する旨を相手方に通知するものとし、開示前に通知を行うことができない場合は開示後すみやかにこれを行うものとします。
３．秘密情報の提供を受けた当事者は、当該秘密情報の管理に必要な措置を講ずるものとします。
４．秘密情報の提供を受けた当事者は、相手方より提供を受けた秘密情報を本サービス遂行目的の範囲内でのみ使用し、本サービス遂行上必要な範囲内で秘密情報を化体した資料等（以下本条において「資料等」といいます。）を複製又は改変（以下本項においてあわせて「複製等」といいます。）することができるものとします。この場合、契約者及び当社は、当該複製等された秘密情報についても、本条に定める秘密情報として取り扱うものとします。なお、本サービス遂行上必要な範囲を超える複製等が必要な場合は、あらかじめ相手方から書面による承諾を受けるものとします。
５．前各項の規定に関わらず、当社が必要と認めた場合には、第２２条（委託）所定の委託先に対して、委託のために必要な範囲で、契約者から事前の書面による承諾を受けることなく秘密情報を開示することができます。ただしこの場合、当社は委託先に対して、本条に基づき当社が負う秘密保持義務と同等のものを負わせるものとします。
６．秘密情報の提供を受けた当事者は、相手方の要請があったときは資料等（本条第４項に基づき相手方の承諾を得て複製、改変した秘密情報を含みます。）を相手方に返還し、秘密情報が契約者設備又は本サービス用設備に蓄積されている場合はこれを完全に消去するものとします。
７．本条の規定は、本サービス終了後、１年間有効に存続するものとします。

（個人情報の取り扱い）
第３５条 契約者及び当社は、本サービス遂行のため相手方より提供を受けた営業上その他業務上の情報に含まれる個人情報（個人情報の保護に関する法律に定める「個人情報」をいいます。以下同じとします。）を本サービス遂行目的の範囲内でのみ使用し、第三者に開示又は漏洩しないものとするとともに、個人情報に関して個人情報の保護に関することを含め関連法令を遵守するものとします。
２．個人情報の取り扱いについては、前条（秘密情報の取り扱い）第３項乃至第６項の規定を準用するものとします。
３．本条の規定は、本サービス終了後も有効に存続するものとします。

（情報管理と生成AIの利用）
第３６条 当社は、契約者及び利用者が本サービスを通じて入力、保存、送信する一切の情報（以下「契約者及び利用者データ」といいます）を、他の契約者及び利用者データと厳格に分離し、それぞれのデータが相互に影響し合わないよう、細心の注意と技術的措置をもって管理します。契約者及び利用者データが他の契約者及び利用者に漏洩すること、またはその他の契約者及び利用者データと混同されることはございません。
２．本サービスに含まれる生成AI機能は、契約者及び利用者データの機密性および独立性を最大限尊重する設計となっております。生成AI機能が契約者及び利用者に提供する回答や出力は、契約者及び利用者ご自身のデータのみに基づいて生成されます。他の契約者及び利用者データが、契約者及び利用者の生成AI機能の学習、分析、または回答生成プロセスに意図せず混入することは一切ございません。また、契約者及び利用者ご自身のデータが、他の契約者及び利用者の生成AI機能の学習、分析、または回答生成プロセスに意図せず混入することも一切ございません。
３．当社は、契約者及び利用者データの収集、分析、利用を、第３７条に定める本サービスの提供および改善の目的に限定し、契約者及び利用者の同意なく契約者及び利用者データを他の契約者及び利用者と共有すること、または特定の契約者及び利用者データを識別可能な形で第三者に開示することはありません。
４．当社は、本条に定める情報管理および生成AIの利用に関する安全性を確保するため、継続的な技術的改善、セキュリティ対策の実施、および運用体制の強化に努め、契約者及び利用者に安心して本サービスをご利用いただける環境を提供します。

（当社が収集する契約者の情報の内容）
第３７条 契約者及び利用者は、本サービスにおいて、当社が、第３８条に規定する目的のため、以下の各号に掲げる情報（以下「各種情報」といいます）を取得すること、および各種情報を当社が契約するクラウドサービス上に保存することに同意するものとします。その際、当社は第３２条（善管注意義務）、第３４条（秘密情報の取り扱い）、第３５条（個人情報の取り扱い）、第３６条（情報管理と生成AIの利用）の義務を負います。
１．利用情報
契約者が入力した以下の情報
  （１）契約者のアカウント情報（会社名、住所、ＴＥＬ、ユーザー名等）
  （２）センサー情報（設置場所、設置日、等）
２．センサーから送信される情報
  （１）センサーに関する情報（センサーID、動作状態等）
  （２）映像データ、静止画データ、送信日時、検出有無に関する情報（ただし、音声データは含まれません）
  （３）その他、対象センサーから得られる情報

（取得した情報の利用目的）
第３８条 当社は、当社が取得した各種情報を以下の目的でのみ利用します。
  （１）本サービスを運営するため、ならびに、本サービスの機能改善および品質向上のため
  （２）対象センサーの稼働状態の確認、故障の診断・検知、改良および修理サービスのため
  （３）本サービスの利用状況の計測・分析・改良のため
  （４）本サービスの障害・不具合時の調査・対応のため

第８章 損害賠償等

（損害賠償の制限）
第３９条 当社が契約者及び利用者に対し、本サービス又は利用契約に関して負う損害賠償の範囲は、本サービスの対価として契約者が当社に支払った額を限度とします。

（免責）
第４０条 本サービス又は利用契約に関して当社が負う責任は、理由の如何を問わず前条の範囲に限られるものとし、当社は、以下の事由により契約者に発生した損害については、債務不履行責任、不法行為責任、その他の法律上の請求原因の如何を問わず賠償の責任を負わないものとします。
  （１）天災地変、騒乱、暴動等の不可抗力
  （２）契約者設備の障害又は本サービス用設備までのインターネット接続サービスの不具合等契約者の接続環境の障害
  （３）本サービス用設備からの応答時間等インターネット接続サービスの性能値に起因する損害
  （４）当社が第三者から導入しているコンピュータウィルス対策ソフトについて当該第三者からウィルスパターン、ウィルス定義ファイル等を提供されていない種類のコンピュータウィルスの本サービス用設備への侵入
  （５）善良なる管理者の注意をもってしても防御し得ない本サービス用設備等への第三者による不正アクセス又はアタック、通信経路上での傍受
  （６）当社が定める手順・セキュリティ手段等を契約者が遵守しないことに起因して発生した損害
  （７）本サービス用設備のうち当社の製造に係らないソフトウェア（ＯＳ、ミドルウェア、ＤＢＭＳ）及びデータベースに起因して発生した損害
  （８）本サービス用設備のうち、当社の製造に係らないハードウェアに起因して発生した損害
  （９）電気通信事業者の提供する電気通信役務の不具合に起因して発生した損害
  （１０）刑事訴訟法第２１８条（令状による差押え・捜索・検証）、犯罪捜査のための通信傍受に関する法律の定めに基づく強制の処分その他裁判所の命令若しくは法令に基づく強制的な処分
  （１１）当社の責に帰すべからざる事由による納品物の搬送途中での紛失等の事故
  （１２）委託先の業務に関するもので、委託先の選任・監督につき当社に過失などの帰責事由がない場合
  （１３）本サービスの機材を屋外で使用したことによる機材の障害
  （１４）本サービスの機材に水を浴びせる、高温な場所に設置することによる機材の障害
  （１５）その他当社の責に帰すべからざる事由
２．当社は、契約者が本サービスを利用することにより契約者と第三者との間で生じた紛争等について一切責任を負わないものとします。

（備考）主な仕様書　※カッコ内は各機器の動作保証温度

Ｒ型
（契約者設備）
ネットワークカメラ（０～５０℃）、ハブ（０～４０℃）、ねずみ解析パソコン（０～４０℃）、ゲートウェイ（０～４０℃）、LANケーブル
（構成によりそれぞれの数の増減あり）
（本サービス用設備）
ねずみ解析プログラム（ねずみ解析パソコンに格納）

Ｆ型
（契約者設備）
Ｆ型本体（０～４０℃）
（本体内訳：捕虫器、カメラ（０～５０℃）、アクチュエーター、アクチュエーター制御用コントローラー、マイクロコンピュータ、ゲートウェイ（０～４０℃））
（本サービス用設備）
Ｆ型制御プログラム（マイクロコンピュータに格納）

Ｓ型
（契約者設備）
Ｓ型本体（０～５０℃）
（本体内訳：カメラ（０～５０℃）、アクチュエーター、アクチュエーター制御用コントローラー、マイクロコンピュータ、タッチパネルスクリーン）
（本サービス用設備）
Ｓ型制御プログラム（マイクロコンピュータに格納）

ＦＣ型
（契約者設備）
ＦＣ型本体（０～４０℃）
（本体内訳：捕虫器、カメラ（０～５０℃）、マイクロコンピュータ、ゲートウェイ（０～４０℃））
（本サービス用設備）
ＦＣ型制御プログラム（マイクロコンピュータに格納）

共通（クラウド）
（本サービス設備）
アマゾンウェブサービス（Pest-Vision Webシステム、飛翔性昆虫解析AI、各種データを格納）
同サービスに接続するための通信、インターネット回線

`;

export const TERMS_FOOTER = '環境機器株式会社　利用規約　PV20250901';
